import { useQuery } from '@tanstack/react-query';
import { Button, Descriptions, Skeleton, Space } from 'antd';
import { IKeys } from 'models';
import { useNavigate, useParams } from 'react-router-dom';
import { MY_WORKS_ROUTE } from 'routes/consts';
import { workService } from 'services';
import { userStore } from 'stores';
import { suppliesPrice } from 'utils';
import { getWorkNumber } from 'utils/get-work-number';

const { Item } = Descriptions;

export const CompletedWork = () => {
	const navigate = useNavigate();
	const params = useParams<{ id: string }>();
	const { data, isLoading } = useQuery({
		queryFn: () => workService.getOne(params?.id || 0),
		queryKey: [IKeys.WORKS, { id: params?.id }]
	});
	const info = data?.acf.foreman_info;

	const suppliesSum = (arr?: any[] | null) => {
		return arr?.reduce((acc: number, el: any) => {
			return acc + suppliesPrice(el.add_item.value) * el.add_item_count;
		}, 0) || 0;
	};

	const arrSum = (prop: string, arr?: any[] | null) => {
		return arr?.reduce((acc: number, el: any) => {
			return acc + +el[prop];
		}, 0) || 0;
	};

	return (!isLoading) ? (
		<Space orientation="vertical" style={{ width: '100%' }} size="large">
			<Descriptions size="small" title={`Job ${getWorkNumber(data)}`} bordered>
				<Item label="Discount">{info?.discount}%</Item>
				<Item label="Deposit">${data?.acf.deposit}</Item>
				<Item label="Total">${info?.total}</Item>
				<Item label="Tips">${info?.tips}</Item>
				<Item label="Salary">${arrSum('salary', info?.workers)}</Item>
				<Item label="Balance">${Number(info?.total) - Number(info?.tips) - arrSum('salary', info?.workers)}</Item>
				<Item label="Supplies">${suppliesSum(info?.add_items)}</Item>
				<Item label="Heavy items">${arrSum('heavy_item_price', info?.heavy_items)}</Item>
				{info?.discount === 'yes' && <Item label="Discount">${info?.discount}</Item>}
				<Item label="Total time">{Math.round((info?.total_time || 0) * 100) / 100}h</Item>
			</Descriptions>
			{!!info?.add_items?.length && (
				<Descriptions size="small" title="Supplies" bordered>
					{info.add_items.map((el) => (
						<Item key={el.add_item} label={el.add_item}>
							${suppliesPrice(el.add_item) * el.add_item_count} / {el.add_item_count}
						</Item>
					))}
				</Descriptions>
			)}
			{!!info?.heavy_items?.length && (
				<Descriptions size="small" title="Heavy items" bordered>
					{info.heavy_items.map((el: any) => (
						<Item key={el.heavy_item} label={el.heavy_item}>
							${el.heavy_item_price}
						</Item>
					))}
				</Descriptions>
			)}
			<Descriptions size="small" title="Workers" bordered>
				{info?.workers?.map((el, index) => (
					<Item 
						key={el?.worker || index} 
						label={userStore.getUser(Number(el?.worker))?.name || `${el.worker_role} ${index}`}>
						${el.salary} / {el.payment_type}
					</Item>
				)
				)}
			</Descriptions>
			<Button type="primary" onClick={() => navigate(`${MY_WORKS_ROUTE}/${data?.id}`)}>Edit work's details</Button>
		</Space>
	) : (
		<Skeleton />
	);
};
